export const HOME_BODY_COLOR = "#F9F8F7";
export const HEART_COLOR = "#C0392B";
export const ARROW_COLOR = "#117A65";
export const VARIABLE_TAG_BACKGROUND = "#fce6df";
export const LIGHT_GREY = "#f1f0ec";
export const DARK_BROWN = "#4F3A10";
export const LIGHT_GREEN = "#DAEBE8";
